import BotConditionCard from "./BotConditionCard";
import React from "react";
import {useWatch} from "react-hook-form";
import ReactHookFormCheckbox from "../../input/ReactHookFormCheckbox";
import ReactHookFormRadio from "../../input/ReactHookFormRadio";
import DeviceVendorMultiSelect from "../../campaigns/conditions/DeviceVendorMultiSelect";
import {Add, Delete} from "@mui/icons-material";
import {Box, Button, IconButton} from "@mui/material";

function BotConditionDeviceVendor(props) {
    const {control, setValue, getValues} = props;

    // Watch the global rules object in real-time
    const rules = useWatch({control, name: "rules"}) || {};
    const deviceVendorData = rules?.deviceVendor;
    const hasDeviceVendorCondition = !!deviceVendorData;

    const radioConditions = [
        {label: "Is", value: "is", color: "primary"},
        {label: "Is not", value: "isNot", color: "error"},
    ];

    // REMOVE: Safe JS delete approach
    const removeCondition = () => {
        const currentRules = {...getValues("rules")};
        delete currentRules.deviceVendor;
        setValue("rules", currentRules);
    };

    // ADD: Initialize flat deviceVendor object
    const addCondition = () => {
        setValue("rules.deviceVendor", {
            condition: "is",
            includeEmptyValue: false,
            values: []
        });
    };

    const renderAddCondition = () => {
        if (!hasDeviceVendorCondition) {
            return (
                <Box display="flex" flexDirection="row" alignItems="center" gap={2}>
                    <Box flexGrow={1} sx={{minWidth: 0, fontSize: 14, fontWeight: 600}}>
                        <span>Device vendor</span>
                    </Box>
                    <Box>
                        <Button
                            aria-label="condition"
                            color="primary"
                            title="Add condition"
                            startIcon={<Add/>}
                            onClick={addCondition}
                            sx={{textTransform: "none", py: 0.25, px: 1}}
                        >
                            Add condition
                        </Button>
                    </Box>
                </Box>
            );
        }
    };

    const renderConditionBox = () => {
        if (hasDeviceVendorCondition) {
            return (
                <>
                    <Box display="flex" flexDirection="row" alignItems="center" gap={2}>
                        <Box flexGrow={1} sx={{minWidth: 0, fontSize: 14, fontWeight: 600}}>
                            Device vendor
                        </Box>
                        <Box>
                            <IconButton
                                aria-label="remove"
                                color="default"
                                title="Remove"
                                size="small"
                                onClick={removeCondition}
                                sx={{color: 'error.dark'}}
                            >
                                <Delete fontSize="small"/>
                            </IconButton>
                        </Box>
                    </Box>
                    <Box>
                        <ReactHookFormRadio
                            control={control}
                            options={radioConditions}
                            name="rules.deviceVendor.condition"
                            label="conditions"
                        />
                    </Box>
                    <Box>
                        <ReactHookFormCheckbox
                            control={control}
                            label="Include empty value"
                            labelPlacement="end"
                            name="rules.deviceVendor.includeEmptyValue"
                        />
                    </Box>
                    <Box sx={{mt: 1}}>
                        <DeviceVendorMultiSelect
                            control={control}
                            inputName="rules.deviceVendor.values"
                            inputLabel="Device vendor"
                        />
                    </Box>
                </>
            );
        }
    };

    return (
        <BotConditionCard>
            {renderAddCondition()}
            {renderConditionBox()}
        </BotConditionCard>
    );
}

export default BotConditionDeviceVendor;
